
const state = {
  id: null,
  node_name: '',
  node_properties: [],
  portal_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'node_name' },
  { key: 'portal_id' },
  { key: 'title' },
]

export default state
